import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  PHONE_INPUT: `${cleanedFilename(__filename)}-phone-input`,
  NAME_INPUT: `${cleanedFilename(__filename)}-name-input`,
  DROPDOWN: `${cleanedFilename(__filename)}-dropdown`,
};
